import { useEffect, useRef } from 'react'
import type { JSX } from 'react'

import { Flex, Heading, SimpleSpinner, Text } from '@buffer-mono/popcorn'

import styles from './LoadingPhase.module.css'

const LOADING_DURATION_MS = 2000

interface LoadingPhaseProps {
  onComplete: () => void
}

/**
 * @hardcoded Heading ("Thanks for choosing Buffer") and subheading ("Here's what you
 *   can do to get started") are fully hardcoded with no API-backed step behind this screen.
 * @fix Either back this with a dedicated API step type (e.g. `LoadingStep`) that
 *   carries the copy, or add a `loadingCopy` field to the preceding `TourStep` type.
 */
export function LoadingPhase({ onComplete }: LoadingPhaseProps): JSX.Element {
  const onCompleteRef = useRef(onComplete)
  onCompleteRef.current = onComplete

  useEffect(() => {
    const timer = setTimeout(() => onCompleteRef.current(), LOADING_DURATION_MS)
    return (): void => clearTimeout(timer)
  }, [])

  return (
    <div className={styles.loading}>
      <Flex direction="column" gap="sm" align="center">
        <Heading as="h1" size="xl" align="center">
          Thanks for choosing Buffer 🌱
        </Heading>
        <Text color="subtle">Here&apos;s what you can do to get started</Text>
      </Flex>
      <SimpleSpinner size="medium" />
    </div>
  )
}
